module.exports = __webpack_public_path__ + "product/icon-edit-d7ddd496a82230fa07fab858cfebeaf6.svg";